import { Injectable } from '@angular/core';
import * as cryptoJs from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() {}

  public aesEncrypt(data: any) {
    var ciphertext = cryptoJs.AES.encrypt(JSON.stringify(data), 'qUDCYQMDUdHmLmKBSx').toString();
    return ciphertext;
  }
  public aesDecrypt(data: string){
    if(data){
      var bytes  = cryptoJs.AES.decrypt(data, 'qUDCYQMDUdHmLmKBSx');
      var decryptedData = JSON.parse(bytes.toString(cryptoJs.enc.Utf8));
      return decryptedData;
    }
    return null;
  }
}
